//arrow animation
const arrow = document.querySelectorAll('.arrow');

if (arrow.length) {
  anime({
    targets: '.arrow, .arrow-pulse',
    keyframes: [
      {translateY: 200},
      {translateX: 260},
      {translateY: 195},
    ],
    duration: 3500,
    easing: 'linear',
    loop: false
  });
}

// Text moving
const textWrapper = document.querySelector('.anime-letter');

if (textWrapper) {
  textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='anime-letter'>$&</span>");

  anime.timeline({
    delay: 2,
    loop: false})
    .add({
      targets: '.anime-letter',
      scale: [4,1],
      opacity: [0,1],
      translateZ: 0,
      easing: "easeOutExpo",
      duration: 1500,
      delay: (el, i) => 70*i
    });

  anime({
    targets: '.rect',
    opacity: [0,1],
    duration: 2000,
    delay:3500,
    easing: 'easeInOutQuad'
  });
}
